module.exports = __webpack_public_path__ + "img/lpfv-pc-2000.483b5185.png";